import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    allFacultyTasksLoading: false,
    allFacultyTasksSuccess: {},
    allFacultyTasksError: '',

    createFacultyTaskLoading: false,
    createFacultyTaskSuccess: {},
    createFacultyTaskError: '',

    getFacultyTaskDetailsLoading: false,
    getFacultyTaskDetailsSuccess: null,
    getFacultyTaskDetailsError: '',

    facultyTasksLoading: false,
    facultyTasksSuccess: {},
    facultyTasksError: '',

    facultyPerformanceLoading: false,
    facultyPerformanceSuccess: {},
    facultyPerformanceError: '',
    facultyMonthlyReportLoading: true,
    facultyMonthlyReportSuccess: null,
    facultyMonthlyReportError: '',

    allAppointmentsLoading: false,
    allAppointmentsSuccess: {},
    allAppointmentsError: '',
    userAppointmentsLoading: false,
    userAppointmentsSuccess: {},
    userAppointmentsError: '',
    appointmentDetailsLoading: false,
    appointmentDetailsSuccess: {},
    appointmentDetailsError: '',
}

export const facultyTaskSlice = createSlice({
    name: 'facultyTask',
    initialState,
    reducers: {

        setAllFacultyTasksLoading: (state, action) => {
            state.allFacultyTasksLoading = true;
            state.allFacultyTasksSuccess = null;
            state.allFacultyTasksError = '';
        },
        setAllFacultyTasksSuccess: (state, action) => {
            state.allFacultyTasksLoading = false;
            state.allFacultyTasksSuccess = action.payload;
            state.allFacultyTasksError = '';
        },
        setAllFacultyTasksError: (state, action) => {
            state.allFacultyTasksLoading = false;
            state.allFacultyTasksSuccess = null;
            state.allFacultyTasksError = action.payload;
        },
        setCreateFacultyTaskLoading: (state) => {
            state.createFacultyTaskLoading = true;
            state.createFacultyTaskSuccess = {};
            state.createFacultyTaskError = '';
        },
        setCreateFacultyTaskSuccess: (state, action) => {
            state.createFacultyTaskLoading = false;
            state.createFacultyTaskSuccess = action.payload;
            state.createFacultyTaskError = '';
        },
        setCreateFacultyTaskError: (state, action) => {
            state.createFacultyTaskLoading = false;
            state.createFacultyTaskSuccess = {};
            state.createFacultyTaskError = action.payload;
        },
        setGetFacultyTaskDetailsLoading: (state) => {
            state.getFacultyTaskDetailsLoading = true;
            state.getFacultyTaskDetailsSuccess = {};
            state.getFacultyTaskDetailsError = '';
        },
        setGetFacultyTaskDetailsSuccess: (state, action) => {
            state.getFacultyTaskDetailsLoading = false;
            state.getFacultyTaskDetailsSuccess = action.payload;
            state.getFacultyTaskDetailsError = '';
        },
        setGetFacultyTaskDetailsError: (state, action) => {
            state.getFacultyTaskDetailsLoading = false;
            state.getFacultyTaskDetailsSuccess = {};
            state.getFacultyTaskDetailsError = action.payload;
        },
        setFacultyTasksLoading: (state, action) => {
            state.facultyTasksLoading = true;
            state.facultyTasksSuccess = null;
            state.facultyTasksError = '';
        },
        setFacultyTasksSuccess: (state, action) => {
            state.facultyTasksLoading = false;
            state.facultyTasksSuccess = action.payload;
            state.facultyTasksError = '';
        },
        setFacultyTasksError: (state, action) => {
            state.facultyTasksLoading = false;
            state.facultyTasksSuccess = null;
            state.facultyTasksError = action.payload;
        },
        setFacultyPerformanceLoading: (state, action) => {
            state.facultyPerformanceLoading = true;
            state.facultyPerformanceSuccess = null;
            state.facultyPerformanceError = '';
        },
        setFacultyPerformanceSuccess: (state, action) => {
            state.facultyPerformanceLoading = false;
            state.facultyPerformanceSuccess = action.payload;
            state.facultyPerformanceError = '';
        },
        setFacultyPerformanceError: (state, action) => {
            state.facultyPerformanceLoading = false;
            state.facultyPerformanceSuccess = null;
            state.facultyPerformanceError = action.payload;
        },
        setFacultyMonthlyClassesReportLoading: (state, action) => {
            state.facultyMonthlyReportLoading = true;
            state.facultyMonthlyReportSuccess = null;
            state.facultyMonthlyReportError = '';
        },
        setFacultyMonthlyClassesReportSuccess: (state, action) => {
            state.facultyMonthlyReportLoading = false;
            state.facultyMonthlyReportSuccess = action.payload;
            state.facultyMonthlyReportError = '';
        },
        setFacultyMonthlyClassesReportError: (state, action) => {
            state.facultyMonthlyReportLoading = false;
            state.facultyMonthlyReportSuccess = null;
            state.facultyMonthlyReportError = action.payload;
        },
        setAllAppointmentsLoading: (state, action) => {
            state.allAppointmentsLoading = true;
            state.allAppointmentsSuccess = null;
            state.allAppointmentsError = '';
        },
        setAllAppointmentsSuccess: (state, action) => {
            state.allAppointmentsLoading = false;
            state.allAppointmentsSuccess = action.payload;
            state.allAppointmentsError = '';
        },
        setAllAppointmentsError: (state, action) => {
            state.allAppointmentsLoading = false;
            state.allAppointmentsSuccess = null;
            state.allAppointmentsError = action.payload;
        },
        setUserAppointmentsLoading: (state, action) => {
            state.userAppointmentsLoading = true;
            state.userAppointmentsSuccess = null;
            state.userAppointmentsError = '';
        },
        setUserAppointmentsSuccess: (state, action) => {
            state.userAppointmentsLoading = false;
            state.userAppointmentsSuccess = action.payload;
            state.userAppointmentsError = '';
        },
        setUserAppointmentsError: (state, action) => {
            state.userAppointmentsLoading = false;
            state.userAppointmentsSuccess = null;
            state.userAppointmentsError = action.payload;
        },
        setAppointmentDetailsLoading: (state, action) => {
            state.appointmentDetailsLoading = true;
            state.appointmentDetailsSuccess = null;
            state.appointmentDetailsError = '';
        },
        setAppointmentDetailsSuccess: (state, action) => {
            state.appointmentDetailsLoading = false;
            state.appointmentDetailsSuccess = action.payload;
            state.appointmentDetailsError = '';
        },
        setAppointmentDetailsError: (state, action) => {
            state.appointmentDetailsLoading = false;
            state.appointmentDetailsSuccess = null;
            state.appointmentDetailsError = action.payload;
        },
        resetDetails: (state) => {
            state.createFacultyTaskSuccess = {};
            state.getFacultyTaskDetailsSuccess = {};
        },
        resetFacultyReport: (state) => {
            state.facultyPerformanceSuccess = {};
        },
    }
})

export const { setGetFacultyTaskDetailsLoading, setGetFacultyTaskDetailsSuccess, setGetFacultyTaskDetailsError,
    setAllFacultyTasksLoading,
    setAllFacultyTasksSuccess,
    setAllFacultyTasksError,
    setCreateFacultyTaskLoading,
    setCreateFacultyTaskSuccess,
    setCreateFacultyTaskError,
    setFacultyTasksLoading,
    setFacultyTasksSuccess,
    setFacultyTasksError,
    setFacultyPerformanceLoading,
    setFacultyPerformanceSuccess,
    setFacultyPerformanceError,
    setFacultyMonthlyClassesReportLoading,
    setFacultyMonthlyClassesReportSuccess,
    setFacultyMonthlyClassesReportError,
    setAllAppointmentsLoading,
    setAllAppointmentsSuccess,
    setAllAppointmentsError,
    setAppointmentDetailsLoading,
    setAppointmentDetailsSuccess,
    setAppointmentDetailsError,
    setUserAppointmentsLoading,
    setUserAppointmentsSuccess,
    setUserAppointmentsError,
    resetDetails,
    resetFacultyReport
} = facultyTaskSlice.actions;


export default facultyTaskSlice.reducer;